<template>
  <div class="acomodar">
    <div class="container-fluid py-4 px-4">

      <form @submit.prevent="Guardar">

        <div class="card shadow-sm border border-1 rounded-3 p-3 mb-3">

          <h5 class="fw-bold text-secondary mb-3">CREACIÓN DE USUARIO</h5>

          <div class="row g-3">

            <div class="col-12 col-md-6 col-lg-4">
              <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                <i class="bi bi-person-vcard text-secondary fs-5"></i>
                DOCUMENTO DE IDENTIDAD:
              </label>
              <input type="text" class="form-control" placeholder="Ingresar contenido" required
                v-model="documentoIdentidad">
            </div>


            <div class="col-12 col-md-6 col-lg-4">
              <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                <i class="bi bi-person-lines-fill text-secondary fs-5"></i>
                APELLIDO PATERNO:
              </label>
              <input type="text" class="form-control" placeholder="Ingresar contenido" required
                v-model="apellidoPaterno">
            </div>


            <div class="col-12 col-md-6 col-lg-4">
              <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                <i class="bi bi-person-lines-fill text-secondary fs-5"></i>
                APELLIDO MATERNO:
              </label>
              <input type="text" class="form-control" placeholder="Ingresar contenido" required
                v-model="apellidoMaterno">
            </div>


            <div class="col-12 col-md-6 col-lg-4">
              <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                <i class="bi bi-person-fill text-secondary fs-5"></i>
                NOMBRES:
              </label>
              <input type="text" class="form-control" placeholder="Ingresar contenido" required v-model="nombre">
            </div>


            <div class="col-12 col-md-6 col-lg-4">
              <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                <i class="bi bi-person-badge-fill text-secondary fs-5"></i>
                USUARIO:
              </label>
              <input type="text" class="form-control" placeholder="Ingresar contenido" required v-model="usuaio">
            </div>


            <div class="col-12 col-md-6 col-lg-4">
              <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                <i class="bi bi-lock-fill text-secondary fs-5"></i>
                CONTRASEÑA:
              </label>
              <div class="input-group">
                <input :type="type" class="form-control" placeholder="Ingresar contraseña" required
                  v-model="contraseña">
                <button type="button" class="btn btn-outline-secondary"
                  @click="type = type === 'password' ? 'text' : 'password'">
                  <i :class="type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </button>
              </div>
            </div>


            <div class="col-12 col-md-6 col-lg-4">
              <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                <i class="bi bi-lock-fill text-secondary fs-5"></i>
                REPETIR CONTRASEÑA:
              </label>
              <div class="input-group">
                <input :type="typeRepetir" class="form-control" required placeholder="Repetir contraseña"
                  v-model="repetirContraseña">

                <button type="button" class="btn btn-outline-secondary"
                  @click="typeRepetir = typeRepetir === 'password' ? 'text' : 'password'">
                  <i :class="typeRepetir === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </button>
              </div>

              <div class="mt-1">
                <small v-if="repetirContraseña.length && contraseña !== repetirContraseña" class="text-danger">
                  Las contraseñas no coinciden
                </small>

                <small v-if="repetirContraseña.length && contraseña === repetirContraseña" class="text-success">
                  Las contraseñas coinciden
                </small>
              </div>
            </div>
            <div class="col-12 col-md-4 d-flex align-items-end">
              <button class="btn btn-success d-flex justify-content-center align-items-center ms-2"
                style="width: 48px; height: 48px;">
                <i class="bi bi-save fs-6"></i>
              </button>
            </div>


          </div>

        </div>

      </form>


      <div class="border border-1 rounded-3 p-3 mb-3">

        <TablaUsuario />

      </div>



      <div class="mx-2">
        <hr />
      </div>

<div class="card shadow-sm mb-3">
        <div class="card-body">

          <div class="row g-4 align-items-center">


            <div class="col-12 col-md-6">
              <form @submit.prevent="GuardarAcceso">

                <h5 class="fw-bold text-secondary mb-3 text-center text-md-start">
                  PERFIL POR USUARIO
                </h5>

                <!-- PERFIL -->
                <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                  <i class="bi bi-building text-secondary fs-6"></i> PERFIL:
                </label>
                <select @change="idPerfil = $event.target.value" class="form-select" required>
                  <option value="" disabled selected>--SELECCIONAR PERFIL--</option>
                  <option v-for="item in ListaPerfil" :key="item.id" :value="item.idPerfil">
                    {{ item.perNombre }}
                  </option>
                </select>


                <label class="fw-bold d-flex align-items-center gap-2 mb-1 reducirTamaño">
                  <i class="bi bi-building text-secondary fs-6"></i> USUARIO:
                </label>
                <select @change="idUsuarios = $event.target.value" class="form-select mb-2" required>
                  <option value="" disabled selected>--SELECCIONAR USUARIO--</option>
                  <option v-for="item in usuarios" :key="item.id" :value="item.idUsuario">
                    {{ item.usuNombres }}
                  </option>
                </select>


                <div class="col-12 col-md-4 d-flex align-items-end">
                  <button class="btn btn-success d-flex justify-content-center align-items-center ms-2"
                    style="width: 48px; height: 48px;">
                    <i class="bi bi-save fs-6"></i>
                  </button>
                </div>
              </form>
            </div>


            <div class="col-12 col-md-6 d-flex justify-content-center">
              <div class="text-center">
                <i class="bi bi-people-fill fs-1 text-secondary"></i>
                <p class="text-muted mt-2">Asignar un perfil a un usuario del sistema</p>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="border border-1 rounded-3 p-3 mb-3 bg-white shadow-sm">
        <TablaUsuarios />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal2 from "sweetalert2";
import Swal from "sweetalert";
import TablaUsuarios from "@/components/Configuracion/Tablas/TablaPerfilxUsuario.vue";

import TablaUsuario from '@/components/Configuracion/Tablas/TablaUsuario.vue'

export default {
  name: "PowerbyUsuario",
  components: {
    TablaUsuario,
    TablaUsuarios,
  },

  data() {
    return {
      documentoIdentidad: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      nombre: "",
      usuaio: "",
      contraseña: "",
      repetirContraseña: "",
      type: "password",
      typeRepetir: "password",
      idUsuario: "",
      idPerfil: "",
      usuarios: [],
    };
  },
  computed: {
    ...mapGetters('acciones', ['ListaCategorias', 'ListaPerfil']),

  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
    this.axios.get("BIClientes/ListarUsuarios").then((r) => {
      console.log(r.data);
      this.usuarios = r.data;
    });

  },


  methods: {


  GuardarAcceso() {
      const from = {
        idUsuario: this.idUsuarios,
        idPerfil: this.idPerfil,
        idUsuCreacion: this.idUsuario,
      };
      console.log(from);
      this.axios.post(`BIClientes/RegistrarAcceso`, from).then((r) => {
        console.log(r.data);
        if (r.data) {
          this.ListarPerfilxUsuario()
          Swal(`Se registro cambios`, "", "success");
        } else {
          Swal2.fire({
            icon: "error",
            title: "EL USUARIO YA ESTA ASOCIADO A UN PERFIL",
            text: "",
            footer: '',
          });
        }
      });
    },
    Guardar() {
      const from = {
        idUsuario: this.idUsuario,
        usuCodigo: this.usuaio,
        usuContrasena: this.contraseña,
        usuDocumento: this.documentoIdentidad,
        usuApePaterno: this.apellidoPaterno,
        usuApeMaterno: this.apellidoMaterno,
        usuNombres: this.nombre,
      };

      console.log(from)
      this.axios.post(`BIClientes/RegistrarUsuario`, from).then((r) => {
        Swal(`Se realizo los cambios`, "", "success");

        if (r.data) {
          this.usuaio = ""
          this.contraseña = ""
          this.documentoIdentidad = ""
          this.apellidoMaterno = ""
          this.apellidoMaterno = ""
          this.nombre = ""
          this.ListarUsuarios()
        }


        console.log(r.data);
      });
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(116, 59, 59, 0.2) 0px 2px 16px 0px;
  margin-top: 9px;
  margin-bottom: 0px;
  padding-bottom: 00%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 0.5%;
  margin-right: 1.3%;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 0%;
}
</style>
